import {Body, Controller , Get, Post } from '@nestjs/common';
import {SaleOrderProcessResponseModel,AllSaleOrderProcessResponseModel, SaleOrderProcessDto}  from '@gtpl/shared-models/masters';
import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler, ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { ApiTags } from '@nestjs/swagger';
import { Any } from 'typeorm';
import {SaleorderprocessTypeDTO} from './dto/sale-order-process-type.dto';
import {SaleOrderProcessTypeService} from './sale-order-process-type.service';
import { SaleorderprocessType } from './sale-order-process-type.entity';
import {SaleOrderProcessTypeRequest} from './dto/sale-order-process-type.request'

@ApiTags('sale-order-process-type')
@Controller('sale-order-process-type')
export class SaleOrderProcessTypeController {
    constructor(private saleorderprocessTypeService : SaleOrderProcessTypeService,private readonly applicationExceptionHandler: ApplicationExceptionHandler
        ){}

    @Post('/createSaleOrderProcessType')
    async createSaleOrderProcessType(@Body() saleorderprocessTypeDTO: SaleorderprocessTypeDTO, isUpdate:boolean=false,
    ): Promise<SaleOrderProcessResponseModel> {
        try {
            return await this.saleorderprocessTypeService.createSaleorderprocessType(saleorderprocessTypeDTO, false);
        } catch (error) {
            // return errorHandler(SaleorderprocessTypeResponseModel,error);
            return this.applicationExceptionHandler.returnException(SaleOrderProcessResponseModel, error);
        }
        }
    @Post('/updateSaleOrderProcessType')
    async updateSaleOrderProcessType(@Body() saleorderprocessTypeDTO ): Promise<SaleOrderProcessResponseModel> {
        try {
            console.log('update SaleorderProcessType');
            return await this.saleorderprocessTypeService.createSaleorderprocessType(saleorderprocessTypeDTO, true);
          } catch (error) {
            // return errorHandler(SaleorderprocessTypeResponseModel, error);
            return this.applicationExceptionHandler.returnException(SaleOrderProcessResponseModel, error);
          }
    }
    @Post('/getallSaleOrderProcessType')
  async getAllSaleOrderProcessType(): Promise<AllSaleOrderProcessResponseModel>  {
    try {
        return await this.saleorderprocessTypeService.getAllSaleorderprocessType();
      } catch (error) {
        // return errorHandler(AllSaleorderprocessTypeResponseModel, error);
        return this.applicationExceptionHandler.returnException(AllSaleOrderProcessResponseModel, error);
      }
      

  }
  
  @Post('/activateOrDeactivateSaleOrderProcessType')
    async activateOrDeactivateSaleOrderProcessType(@Body() saleorderReq: SaleOrderProcessTypeRequest): Promise<SaleOrderProcessResponseModel> {
        try {
            return await this.saleorderprocessTypeService.activateOrDeactivateSaleOrderProcessType(saleorderReq);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(SaleOrderProcessResponseModel, err);
        }
    }


}
